import http from './http';
import { listResource } from './listResource';

// Routines
// Listar rutinas
export async function listRoutines(options = {}) {
  return listResource('/routines', options);
}

// Obtener una rutina por su ID
export async function getRoutineById(id) {
  const res = await http.get(`/routines/${id}`);
  return res.data?.data ?? res.data;
}

// Crear una nueva rutina
export async function createRoutine(payload) {
  const res = await http.post('/routines', payload);
  return res.data?.data ?? res.data;
}

// Actualizar una rutina existente
export async function updateRoutine(id, payload) {
  const res = await http.put(`/routines/${id}`, payload);
  return res.data?.data ?? res.data;
}

// Eliminar Rutina
export const deleteRoutine = (id) => http.delete(`/routines/${id}`);

// Subir archivo de imagen para rutina
export async function uploadRoutineMedia(file) {
  const formData = new FormData();
  formData.append('file', file);

  const res = await http.post('/files/upload/routine', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  const responseData = res.data?.data ?? res.data;
  return {
    url: responseData?.url ?? responseData,
    preview_url: responseData?.preview_url ?? null,
  };
}

// Verificar si un título ya existe
export async function checkRoutineTitleExists(title, excludeId = null) {
  try {
    const { items } = await listRoutines({ search: title });
    const exists = items?.some(
      (routine) =>
        routine.title?.toLowerCase() === title?.toLowerCase() &&
        routine.id !== excludeId
    );
    return exists;
  } catch (error) {
    console.error('Error al verificar título:', error);
    return false;
  }
}

// Publicar rutina
export async function publishRoutine(id) {
  const res = await http.post(`/routines/${id}/publish`);
  return res.data?.data ?? res.data;
}

// Clonar rutina
export const cloneRoutine = (id) => http.post(`/routines/${id}/clone`);

// Routine Days
// Listar días de una rutina
export async function getRoutineDays(routineId) {
  const res = await http.get(`/routines/${routineId}/days`);
  return res.data?.data ?? res.data;
}

// Crear un día
export async function createRoutineDay(routineId, payload) {
  const res = await http.post(`/routines/${routineId}/days`, payload);
  return res.data?.data ?? res.data;
}

// Actualizar un día
export async function updateRoutineDay(routineId, dayId, payload) {
  const res = await http.put(`/routines/${routineId}/days/${dayId}`, payload);
  return res.data?.data ?? res.data;
}

// Eliminar un día
export async function deleteRoutineDay(routineId, dayId) {
  const res = await http.delete(`/routines/${routineId}/days/${dayId}`);
  return res.data?.data ?? res.data;
}

// Duplicar semana completa de una rutina 
export async function duplicateRoutineWeek(routineId, weekNumber) {
  const res = await http.post(`/routines/${routineId}/weeks/${weekNumber}/duplicate`);
  return res.data?.data ?? res.data;
}

// Actualizar warm-up del día
export async function updateRoutineDayWarmUp(routineId, dayId, warmUpId) {
  const res = await http.put(`/routines/${routineId}/days/${dayId}/warm-up`, {
    warm_up_id: warmUpId,
  });
  return res.data?.data ?? res.data;
}

// Actualizar estiramiento del día
export async function updateRoutineDayStretch(routineId, dayId, stretchId) {
  const res = await http.put(`/routines/${routineId}/days/${dayId}/stretch`, {
    stretch_id: stretchId,
  });
  return res.data?.data ?? res.data;
}

// Routine Day Exercises
/**
 * Normaliza la respuesta del listado de ejercicios del día.
 * Formato nuevo: { exercise_groups, standalone_exercises, total_groups, total_standalone }
 * Formato legado: array plano de ejercicios.
 */
export function normalizeRoutineDayExercisesResponse(payload) {
  const raw = payload;
  if (raw == null) return { exerciseGroups: [], standaloneExercises: [] };
  if (Array.isArray(raw)) {
    return { exerciseGroups: [], standaloneExercises: raw };
  }
  const exerciseGroups = raw.exercise_groups ?? raw.exerciseGroups ?? [];
  const standaloneExercises = raw.standalone_exercises ?? raw.standaloneExercises ?? [];
  return {
    exerciseGroups: Array.isArray(exerciseGroups) ? exerciseGroups : [],
    standaloneExercises: Array.isArray(standaloneExercises) ? standaloneExercises : [],
  };
}

export async function listRoutineDayExercises(routineId, dayId) {
  const res = await http.get(`/routines/${routineId}/days/${dayId}/exercises`);
  return res.data?.data ?? res.data?.items ?? res.data ?? null;
}

export async function createRoutineDayExercise(routineId, dayId, payload) {
  const res = await http.post(`/routines/${routineId}/days/${dayId}/exercises`, payload);
  return res.data?.data ?? res.data;
}

export async function updateRoutineDayExercise(routineId, dayId, routineDayExerciseId, payload) {
  const res = await http.put(
    `/routines/${routineId}/days/${dayId}/exercises/${routineDayExerciseId}`,
    payload
  );
  return res.data?.data ?? res.data;
}

export async function deleteRoutineDayExercise(routineId, dayId, routineDayExerciseId) {
  const res = await http.delete(
    `/routines/${routineId}/days/${dayId}/exercises/${routineDayExerciseId}`
  );
  return res.data?.data ?? res.data;
}

// Routine day exercise groups
export async function listRoutineDayExerciseGroups(routineId, dayId) {
  const res = await http.get(`/routines/${routineId}/days/${dayId}/exercise-groups`);
  const raw = res.data?.data ?? res.data;
  if (Array.isArray(raw)) return raw;
  if (Array.isArray(raw?.items)) return raw.items;
  return [];
}

export async function createRoutineDayExerciseGroup(routineId, dayId, payload) {
  const res = await http.post(`/routines/${routineId}/days/${dayId}/exercise-groups`, payload);
  return res.data?.data ?? res.data;
}

export async function updateRoutineDayExerciseGroup(routineId, dayId, groupId, payload) {
  const res = await http.put(
    `/routines/${routineId}/days/${dayId}/exercise-groups/${groupId}`,
    payload
  );
  return res.data?.data ?? res.data;
}

export async function deleteRoutineDayExerciseGroup(routineId, dayId, groupId) {
  const res = await http.delete(`/routines/${routineId}/days/${dayId}/exercise-groups/${groupId}`);
  return res.data?.data ?? res.data;
}

